import React from "react";
const COST_SHEET_IMAGE = "https://cdn.magicpatterns.com/uploads/9hL22SvFwwDH7WvYq9aZqb/plantillas_de_excel_para_reposteria.webp";
export function CostSheetPreview() {
  return <div className="overflow-hidden rounded-xl bg-cream-50 ring-1 ring-cocoa-900/10" data-id="element-73" data-mp="3kzoauscci0ne">
      <img src={COST_SHEET_IMAGE} alt="Planillas de Excel para repostería: ficha de producto, pedidos y cobros, lista de productos y guía en tres pasos" width={1448} height={1086} loading="lazy" className="block h-auto w-full" data-id="element-74" data-mp="3pq4n494fjg86" />
    </div>;
}